import authService from "api/authService"
import { useMutation } from "react-query"
import { IAuthorizeByOtpBody } from "./authMutationsTypes"

const useAuthorizeByOtpMutation = () => {
  return useMutation( async ({ fcmToken, data }:{ fcmToken: string, data: IAuthorizeByOtpBody  }) => {
    try {
      const res = await authService.authorizeByOtp(fcmToken, data)

      return res.data
    } catch (err: any) {
      return {
        err: err.message,
        errStatus: err.response.status,
      }
    }
  })
}

export default useAuthorizeByOtpMutation
